import { useContext } from 'react';
import restClient from 'Shared/hooks/restClient'
import survey from './survey'

const actionSlices = {
  survey,
}

export default () => {
  const dis = useDis()
  const store = useStore()

  return useMemo(
    () => _.mapValues(actionSlices, (fn) => {
      return fn(dis, store, restClient)
    }),
    []
  )
}

